import { create } from 'zustand';
import { podarLidas } from '@/domain/notificacoes/sino';

/**
 * Notificações do sino já lidas (C-24) — chaves `NotificacaoDoSino.chaveLeitura`.
 *
 * Em memória, como o `NOTIF_READ` do protótipo V8: recarregar a página volta tudo a não
 * lido. É o lado conservador num app de segurança — esquecer um "lido" custa um número no
 * badge; lembrar um "lido" errado esconderia uma pendência. "Lido" só apaga o badge; o
 * item continua no sino até a pendência ser resolvida.
 *
 * Duas limpezas: `podar` esquece o "lido" do que saiu do sino (pendência que volta conta
 * de novo) e `limpar` zera tudo no logout (posto de vigilância compartilhado: o
 * plantonista seguinte não herda os "lidos" do anterior).
 */
interface NotificacoesState {
  lidas: ReadonlySet<string>;
  marcarLida: (chave: string) => void;
  marcarTodasLidas: (chaves: readonly string[]) => void;
  podar: (chavesAtuais: readonly string[]) => void;
  limpar: () => void;
}

export const useNotificacoesStore = create<NotificacoesState>((set) => ({
  lidas: new Set<string>(),
  marcarLida: (chave) =>
    set((s) => (s.lidas.has(chave) ? s : { lidas: new Set([...s.lidas, chave]) })),
  marcarTodasLidas: (chaves) => set((s) => ({ lidas: new Set([...s.lidas, ...chaves]) })),
  podar: (chavesAtuais) =>
    set((s) => {
      const lidas = podarLidas(s.lidas, chavesAtuais);
      return lidas === s.lidas ? s : { lidas };
    }),
  limpar: () => set({ lidas: new Set<string>() }),
}));
